var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveCasinoMob({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6062_4737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1635 20.1241H7.83646C7.37885 20.1241 7.00375 19.749 7.00375 19.2914C7.00375 18.8337 7.37885 18.4586 7.83646 18.4586H16.171C16.6287 18.4586 17.0038 18.8337 17.0038 19.2914C17.0038 19.749 16.6287 20.1241 16.171 20.1241H16.1635ZM20.3346 3.875C21.2573 3.875 22 4.62519 22 5.54042V15.5404C22 16.4631 21.2498 17.2058 20.3346 17.2058H3.66542C2.74269 17.2058 2 16.4556 2 15.5404V5.54042C2 4.62519 2.75019 3.875 3.66542 3.875H20.3346ZM14.5881 10.7617C14.8957 10.6117 14.8957 10.1691 14.5881 10.019L10.9347 8.19608C10.6572 8.06105 10.3346 8.2561 10.3346 8.57117V12.2246C10.3346 12.5322 10.6572 12.7347 10.9347 12.5997L14.5881 10.7767V10.7617Z",
    fill: "#8C8989"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6062_4737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16.2491,
    fill: "white",
    transform: "translate(2 3.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveCasinoMob);
export default __webpack_public_path__ + "static/media/LiveCasinoMob.e324538eb210d8982c1e6031d8bf30f9.svg";
export { ForwardRef as ReactComponent };